<template>
  <div id="content">
    <section id="user">
      <div class="input_list">
        <input type="text" style="top: -100px; left: -100px; position: fixed;">
        <input type="password" style="top: -100px; left: -100px; position: fixed;">
        <ul>
          <li>
            <span>
              <label class="list_key">{{label.corpType}}</label>
              <label class="important">必須</label>
            </span>
            <select class="list_box" v-model.number="userForm.corpType">
              <option value='' class="select_placeholder">選択してください</option>
              <option v-for="(type,index) in corpTypeList" :key="'corptype-' + index" v-bind:value="type.code">{{type.label}}</option>
            </select>
            <label v-if="errors.corpType" class="error_text">{{errors.corpType}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.corpDept}}</label>
              <label class="important">必須</label>
            </span>
            <input type="text" class="list_box" v-model="userForm.corpDept" maxlength="32"/>
            <label v-if="errors.corpDept" class="error_text">{{errors.corpDept}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.userName}}</label>
              <label class="important">必須</label>
            </span>
            <div class="list_box">
              <input type="text" class="list_box" v-model="userForm.userLastName" placeholder="家具" maxlength="32"/>
              <input type="text" class="list_box" v-model="userForm.userFirstName" placeholder="太郎" maxlength="32"/>
            </div>
            <label v-if="errors.userName" class="error_text">{{errors.userName}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.userNameKana}}</label>
              <label class="important">必須</label>
            </span>
            <div class="list_box">
              <input type="text" class="list_box" v-model="userForm.userLastNameKana" placeholder="カグ" maxlength="32"/>
              <input type="text" class="list_box" v-model="userForm.userFirstNameKana" placeholder="タロウ" maxlength="32"/>
            </div>
            <label v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</label>
          </li>
          <li v-if="!isEdit">
            <span>
              <label class="list_key">{{label.email}}</label>
              <label class="important">必須</label>
              <label class="small_p">仮登録したアドレスと間違いがないかご確認ください。</label>
            </span>
            <input type="text" class="list_box" v-model.trim="userForm.email" placeholder="****@domans.co.jp" maxlength="128" v-bind:disabled="!isEdit"/>
            <label v-if="errors.email" class="error_text">{{errors.email}}</label>
          </li>
          <template v-if="!isEdit">
            <li>
              <span>
                <label class="list_key">{{label.password}}</label>
                <label class="important">必須</label>
                <label class="small_p">半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。</label>
              </span>
              <input type="password" class="list_box" v-model="userForm.password" maxlength="20" autocomplete="new-password"/>
              <label v-if="errors.password" class="error_text">{{errors.password}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.confirmPassword}}</label>
                <label class="important">必須</label>
              </span>
              <input type="password" class="list_box" v-model="userForm.confirmPassword" maxlength="20" autocomplete="new-password"/>
              <label v-if="errors.confirmPassword" class="error_text">{{errors.confirmPassword}}</label>
            </li>
          </template>
          <li v-if="!isEdit">
            <label class="list_key">mm/styleをどこで知りましたか？</label>
            <select class="list_box" v-model.number="userForm.infosrc">
              <option value='' class="select_placeholder">選択してください</option>
              <option v-for="(type,index) in infoSrcList" :key="'infosrc-' + index" v-bind:value="type.code">{{type.label}}</option>
            </select>
          </li>
          <li class="rule_parts" v-if="!isEdit">
            <dd-user-rule-detial
            />
          </li>
          <li v-if="!isEdit">
            <label>
              <input type="checkbox" v-model="userForm.consent"/>
              利用規約に同意する。
            </label>
          </li>
          <li>
            <label >
              <input type="checkbox" v-model="userForm.recvInfo"/>
              メールマガジンを受け取る。
            </label>
          </li>
        </ul>
        <span class="notes" v-if="isRequestPayment">
          <p>※掛払い決済は審査後にご利用いただけます。</p>
          <p class="indent">審査結果は通常３営業日以内にメールでお知らせいたします。</p>
          <p class="indent">審査完了まではカード決済、銀行振込でご利用いただけます。</p>
        </span>
      </div>
    </section>
    <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'
import {CORP_TYPE, INFO_SRC} from '../../constants/TypeEc'
import UseRuleDetial from '../common/UseRuleDetial'

export default {
  name: 'UserInput',
  components: {
    'dd-user-rule-detial': UseRuleDetial
  },
  props: {
    leftBtnLabel: String,
    rightBtnLabel: String,
    isEdit: Boolean,
    userForm: Object,
    isRequestPayment: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errors: {},
      label: {
        corpType: '業種',
        corpName: '会社名',
        corpBranchName: '支店名・営業所名',
        corpDept: '所属部署',
        userName: '氏名',
        userNameKana: '氏名（カナ）',
        email: 'メールアドレス',
        password: 'パスワード',
        confirmPassword: 'パスワード（確認用）',
        tel: '電話番号',
        fax: 'FAX',
        postcd: '郵便番号',
        state: '住所',
        street: '以下住所'
      },
      isPasswordUpdate: false
    }
  },
  computed: {
    corpTypeList: function () {
      return Object.keys(CORP_TYPE)
        .map(e => CORP_TYPE[e])
    },
    infoSrcList: function () {
      return Object.keys(INFO_SRC)
        .map(e => INFO_SRC[e])
    }
  },
  methods: {
    confirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      this.validatedPassword()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }

      return true
    },
    validateRequire: function () {
      if (this.userForm.corpType === undefined || this.userForm.corpType === '') {
        this.errors['corpType'] = this.label.corpType + 'は必須項目です。'
      }
      if (!this.userForm.corpDept) {
        this.errors['corpDept'] = this.label.corpDept + 'は必須項目です。'
      }
      if (!this.userForm.userLastName || !this.userForm.userFirstName) {
        this.errors['userName'] = this.label.userName + 'は必須項目です。'
      }
      if (!this.userForm.userLastNameKana || !this.userForm.userFirstNameKana) {
        this.errors['userNameKana'] = this.label.userNameKana + 'は必須項目です。'
      }
      if (!this.isEdit) {
        if (!this.userForm.email) {
          this.errors['email'] = this.label.email + 'は必須項目です。'
        }
        if (!this.userForm.password) {
          this.errors['password'] = this.label.password + 'は必須項目です。'
        }
        if (!this.userForm.confirmPassword) {
          this.errors['confirmPassword'] = this.label.confirmPassword + 'は必須項目です。'
        }
      }
    },
    validateFormat: function () {
      if (!Check.isKana(this.userForm.userLastNameKana) || !Check.isKana(this.userForm.userFirstNameKana)) {
        this.errors['userNameKana'] = this.label.userNameKana + 'はカタカナで入力してください。'
      }
      if (!this.isEdit) {
        if (!Check.isMail(this.userForm.email)) {
          this.errors['email'] = 'メールアドレスの形式ではありません。'
        }
      }
      if (!this.isEdit) {
        if (!Check.isPassword(this.userForm.password)) {
          this.errors['password'] = this.label.password + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
        }
        if (!Check.isPassword(this.userForm.confirmPassword)) {
          this.errors['confirmPassword'] = this.label.confirmPassword + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
        }
      }
    },
    validatedPassword: function () {
      if (this.userForm.password !== this.userForm.confirmPassword) {
        this.errors['confirmPassword'] = this.label.confirmPassword + 'が一致しません'
      }
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    }
  },
  created () {
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/UserInput.vue